import { render } from "./Formato2019.vue?vue&type=template&id=86bd8c0e&scoped=true"
import script from "./Formato2019.vue?vue&type=script&lang=js"
export * from "./Formato2019.vue?vue&type=script&lang=js"

import "./Formato2019.vue?vue&type=style&index=0&id=86bd8c0e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86bd8c0e"]])

export default __exports__